import { HeightType, WeightType } from '@/Types/gql/graphql';
import { z } from 'zod';

// Simplified signup schema
export const simplifiedSignupSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required.' }),
  lastName: z.string().min(1, { message: 'Last name is required.' }),
  email: z
    .string()
    .min(1, { message: 'Email is required.' })
    .email({ message: 'Invalid email address.' }),
  referralCode: z.string().optional(),
  terms: z.boolean().refine((val) => val === true, {
    message:
      'Please review and accept the Terms & Conditions, Privacy Policy, and Waiver of Liabilities to proceed.',
  }),
  ageConfirmation: z.boolean().refine((val) => val === true, {
    message: 'You must confirm that you are 13 years of age or older.',
  }),
});

// Profile completion schema - combines all detailed fields
export const profileCompletionSchema = z.object({
  gender: z.string().min(1, { message: 'Gender is required.' }),
  ageRange: z.string().min(1, { message: 'Select an age range' }),
  country: z.string().optional(),
  location: z.string().optional(),
  weight: z.number().optional(),
  weightType: z.string(),
  height: z.number().optional(),
  heightType: z.string(),
  languages: z
    .array(z.string().min(1, { message: 'At least one language is required.' }))
    .min(1, { message: 'At least one language is required.' }),
  // fitnessGoals: z.string().min(1, { message: 'fitness goal is required.' }),
  // typeOfWorkouts: z.array(z.string()).min(1, { message: 'Select at least one type of workout' }),
  equipments: z.array(z.string()).optional(),
  isPhysicalActivities: z.boolean(),
  physicalActivities: z.string().optional(),
  // workoutInterval: z.string().min(1, { message: 'Select your workout routine' }),
  contactVia: z.string().optional(),
});

export const stepOneSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required.' }),
  lastName: z.string().min(1, { message: 'Last name is required.' }),
  gender: z.string().min(1, { message: 'Gender is required.' }),
  email: z
    .string()
    .min(1, { message: 'Email is required.' })
    .email({ message: 'Invalid email address.' }),
  // dateOfBirth: z
  //   .string()
  //   .min(1, { message: 'Date of birth is required.' })
  //   .refine(
  //     (dob) => {
  //       const age = dayjs().diff(dayjs(dob), 'year');
  //       return age >= 18;
  //     },
  //     { message: 'Your age should be above 18 years' },
  //   ),
  ageRange: z.string().min(1, { message: 'Select an age range' }),
  country: z.string().optional(),
  location: z.string().optional(),
  // weight: z.number().positive({ message: 'Weight is required' }),
  weight: z.number().optional(),
  weightType: z.string(),
  // height: z.number().positive({ message: 'Height is required' }),
  height: z.number().optional(),
  heightType: z.string(),
  languages: z
    .array(z.string().min(1, { message: 'At least one language is required.' }))
    .min(1, { message: 'At least one language is required.' }),
  terms: z.boolean().refine((val) => val === true, {
    message:
      'Please review and accept the Terms & Conditions, Privacy Policy, and Waiver of Liabilities to proceed.',
  }),
});

export const stepTwoSchema = z.object({
  // fitnessGoals: z.string().min(1, { message: 'fitness goal is required.' }),
  // isMedicalCondition: z.boolean().optional(),
  // medicalCondition: z.string().optional(),
  // typeOfWorkouts: z.array(z.string()).min(1, { message: 'Select at least one type of workout' }),
  equipments: z.array(z.string()).optional(),
  isPhysicalActivities: z.boolean(),
  physicalActivities: z.string().optional(),
  // workoutInterval: z.string().min(1, { message: 'Select your workout routine' }),
  contactVia: z.string().optional(),
});

// Default values for simplified signup
export const simplifiedSignupDefaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  referralCode: '',
  terms: false,
  ageConfirmation: false,
};

// Default values for profile completion
export const profileCompletionDefaultValues = {
  gender: '',
  ageRange: '',
  country: '',
  location: '',
  heightType: HeightType.Centimeter,
  weightType: WeightType.Kilogram,
  height: 0,
  weight: 0,
  languages: [],
  fitnessGoals: '',
  isPhysicalActivities: undefined,
  physicalActivities: '',
  equipments: [],
  typeOfWorkouts: [],
  workoutInterval: '',
  contactVia: '',
};

export const StepOneDefaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  dateOfBirth: '',
  location: '',
  gender: '',
  heightType: HeightType.Centimeter,
  weightType: WeightType.Kilogram,
  height: 0,
  weight: 0,
  languages: [],
  ageRange: '',
  terms: false,
};

export const StepTwoDefaultValues = {
  fitnessGoals: '',
  // isMedicalCondition: undefined,
  isPhysicalActivities: undefined,
  // medicalCondition: '',
  physicalActivities: '',
  equipments: [],
  typeOfWorkouts: [],
  workoutInterval: '',
  contactVia: '',
};
